import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

let timer = null;
// Debounced "last activity" write — last call wins, guests are ignored by callers.
export function saveResume(entry) {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => { api.put("/resume", entry).catch(() => {}); }, 700);
}
export const clearResume = () => { if (timer) clearTimeout(timer); return api.delete("/resume").catch(() => {}); };
export const fetchResume = () => api.get("/resume").then((r) => r.data || null).catch(() => null);

export function useResumeSaver() {
  const { user } = useAuth();
  return useCallback((entry) => { if (user) saveResume(entry); }, [user]);
}

export function useResume() {
  const { user } = useAuth();
  const [resume, setResume] = useState(null);
  useEffect(() => {
    if (!user) { setResume(null); return; }
    let on = true;
    fetchResume().then((r) => { if (on) setResume(r); });
    return () => { on = false; };
  }, [user]);
  return resume;
}
